import openPreviewBite from './openPreviewBite';

const openShareBite = (biteId: number) => {
  openPreviewBite({
    biteId,
    shareOnMount: true,
  });
};
export default openShareBite;
